import React, { useState } from "react";
import Icon from "components/AppIcon";

const TradeHistory = ({ trades }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <button onClick={() => setExpanded(v => !v)}
        className="w-full flex items-center justify-between p-4 md:p-5 hover:bg-primary/5 transition-colors duration-150">
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={16} color="var(--color-primary)" />
          <span className="font-heading text-sm font-semibold text-foreground">Recent Trade History</span>
        </div>
        <Icon name={expanded ? "ChevronUp" : "ChevronDown"} size={16} color="var(--color-muted-foreground)" />
      </button>
      {expanded && (
        <div className="px-4 md:px-5 pb-4 md:pb-5">
          <div className="overflow-x-auto">
            <table className="w-full text-xs font-mono">
              <thead>
                <tr className="border-b border-border">
                  {["Time", "Side", "Price", "Quantity", "Total", "Player"]?.map(h => (
                    <th key={h} className="text-left py-2 pr-4 text-muted-foreground font-caption font-medium uppercase tracking-wider whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {trades?.map((t, i) => (
                  <tr key={i} className="border-b border-border/30 hover:bg-primary/5 transition-colors duration-100">
                    <td className="py-2 pr-4 text-muted-foreground whitespace-nowrap">{t?.time}</td>
                    <td className="py-2 pr-4 whitespace-nowrap">
                      <span className="px-1.5 py-0.5 rounded text-xs font-caption font-semibold"
                        style={t?.side === "BUY"
                          ? { background: "rgba(16,185,129,0.12)", color: "var(--color-success)" }
                          : { background: "rgba(239,68,68,0.12)", color: "var(--color-error)" }}>
                        {t?.side}
                      </span>
                    </td>
                    <td className="py-2 pr-4 text-foreground whitespace-nowrap">${t?.price?.toFixed(2)}</td>
                    <td className="py-2 pr-4 text-foreground whitespace-nowrap">{t?.quantity?.toLocaleString()}</td>
                    <td className="py-2 pr-4 whitespace-nowrap" style={{ color: "var(--color-accent)" }}>
                      ${(t?.price * t?.quantity)?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td className="py-2 pr-4 text-muted-foreground whitespace-nowrap">{t?.player}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default TradeHistory;